/**
 * Account security capability flags.
 *
 * These flags control which self-service security management features are
 * available to users. A disabled capability is omitted from effective routes,
 * persona menus, renderer ownership, and executable operation grants.
 */
export const ACCOUNT_SECURITY_CAPABILITIES = {
    /** Authenticated password change — enabled. */
    passwordChange: true,
    /** Self-service MFA enrollment, recovery-code management, and disablement. */
    mfaManagement: true,
    /** Session management (view, revoke) — enabled. */
    sessionManagement: true,
};
